/**
 * Reports failures that happen while resolving the anonymous device id itself.
 * This module must not import the identity layer; keeping it independent breaks
 * the otherwise unavoidable identity -> reporter -> identity cycle.
 */
export function reportUnlinkedException(cause: unknown, source: string): void {
  if ((cause instanceof Error || cause instanceof DOMException) && cause.name === 'AbortError') {
    return
  }
  if (typeof window === 'undefined') return
  const loader = (
    window as unknown as {
      Sentry?: {
        captureException?: (exception: unknown, context?: { tags?: Record<string, string> }) => void
      }
    }
  ).Sentry
  loader?.captureException?.(cause, {
    tags: { report_type: 'handled_exception', source },
  })
}
